/**
 * URL-string-helpers, gedeeld door de API-clients (chat, customers, AAVA).
 */

/**
 * Verwijdert één trailing slash zodat `${base}${path}` geen
 * dubbele slashes geeft. Sommige servers accepteren die wel, andere
 * geven 404 — beter is om client-side te normaliseren.
 */
export function stripTrailingSlash(s: string): string {
  return s.endsWith('/') ? s.slice(0, -1) : s;
}
